import React, { useCallback } from 'react'
import { Button, YStack } from '@red-ui/components'
import { useNavigate } from 'react-router-dom'
import { getIsAuthenticated } from 'data/src/redux/auth/selectors'
import { useAppSelector } from '../../redux/hooks/hooks'
import { isUrlExternal } from '../../helpers/urlHelper'

interface DynamicButtonFields {
  styleVariant: 'primary' | 'secondary'
  text: string
  textLoggedIn?: string
  target?: string
  triggerFunction?: string
}

type ActionMapType = { [key: string]: () => void }

const functionMapping: ActionMapType = {
  TEST_RELOAD: () => window.location.reload(),
  CREDIT_CARD_APPLY: () => console.log('Credit card apply function triggered'),
}

export const DynamicButton = ({ fields, actionMap = functionMapping }: { fields: DynamicButtonFields; actionMap?: ActionMapType }) => {
  const navigate = useNavigate()
  const isAuthenticated = useAppSelector(getIsAuthenticated)
  const { styleVariant, text, textLoggedIn, target, triggerFunction } = fields

  const handlePress = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      if (target) {
        if (isUrlExternal(target)) window.location.href = target
        else navigate(target)
        return
      }
      if (triggerFunction) {
        const triggerFn = actionMap[triggerFunction]
        if (triggerFn) triggerFn()
      }
    },
    [target, triggerFunction, actionMap, navigate]
  )

  return (
    <YStack alignItems="flex-start">
      <Button
        variant={styleVariant === 'primary' ? undefined : styleVariant}
        paddingHorizontal="$6"
        minHeight="$6"
        size="$3"
        fontWeight={600}
        onPress={handlePress}
      >
        {isAuthenticated && textLoggedIn ? textLoggedIn : text}
      </Button>
    </YStack>
  )
}
